import styles from './FilterBar.module.scss'
import React, { useTransition } from 'react'
import Button from '@/components/buttons/Button/Button'
import { useTranslation } from 'next-i18next'
import classNames from 'classnames'

type Props = {
  items: FilterItem[]
  selected: string,
  onClick: (property: string) => void
}

export interface FilterItem {
  property: string,
  placeholder: string,
  value: () => string | JSX.Element
}

interface FilterItemProps extends FilterItem {
  onClick: (property: string) => void,
  active: boolean
}

const FilterBarItem = (props: FilterItemProps) => {
  const onClick = () => {
    props.onClick(props.property)
  }

  return (
    <div
      className={classNames(styles.item, { [styles.active]: props.active })}
      onClick={onClick}
    >
      <div>{props.placeholder}</div>
      <div>{props.value()}</div>
    </div>
  )
}

const FilterBar = (props: Props) => {
  const [selected, setSelected] = React.useState(props.selected)
  const { t } = useTranslation('common')

  const onFilterButtonClick = (property: string) => {
    setSelected(property)
    props.onClick(property)
  }

  // method to find next item in props.items based on selected
  const onClickNext = () => {
    const index = props.items.findIndex((item) => item.property === selected)
    const next = props.items[index + 1]
    if (next) {
      setSelected(next.property)
      props.onClick(next.property)
    } else {
      setSelected('')
      props.onClick('')
    }
  }

  const classes = classNames(styles.component, {
    [styles.noSelected]: selected === ''
  })
  
  return (
    <div className={classes}>
      {
        props.items?.map((item, index) =>
          <>
            <FilterBarItem
              key={item.property}
              property={item.property}
              placeholder={item.placeholder}
              value={item.value}
              onClick={onFilterButtonClick}
              active={selected === item.property}
            />
          </>
        )
      }
    </div>
  )
}

export default FilterBar